import sanitizeHtml from 'sanitize-html';
import PageManager from '../pages/PageManager';

export const wordCounter = (str) => str.split(' ').filter((n) => n !== '').length;

export const cleanText = (text) =>
  sanitizeHtml(text, {
    allowedTags: [],
    allowedAttributes: {},
  });

export const getDisplayName = (WrappedComponent) =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component';

export const addUid = (arr) =>
  arr.map((item, index) => {
    return {
      ...item,
      id: `event-${index}`,
      type: item.type === 'ctw' ? 'pack' : item.type,
    };
  });

export const groupByKey = (arr, reducer, key, initial = {}) => arr.reduce(reducer(key), initial);

export const arrayObjectReducer = (key) => (acc, curr) => ({
  ...acc,
  [curr[key]]: {
    ...acc[curr[key]],
    [curr.id]: {
      ...curr,
      type: `${curr.type}${(curr.tier && 'Tier') || ''}`,
    },
  },
});

export const objectReducer = (key) => (acc, curr) => ({
  ...acc,
  [curr[key]]: {
    ...curr,
    type: `${curr.type}${(curr.tier && 'Tier') || ''}`,
  },
});

export const getPageById = (id) => PageManager[id];
